import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import { ElementState } from '@/elements/base/ElementState';
import { ComponentLookup } from '@/ui-kit/domain/ComponentLookup';
import { componentLookupBehaviour, attributeLookupBehaviour } from '@/ui-kit/domain/lookup/behaviours';
import { ProductLookup } from '@/ui-kit/domain/lookup/ProductLookup';
import { IUICfgComponent } from '@canvas-logic/clp-api-types';

let id = 0;

export class ComponentElementState extends ElementState {
  readonly elementKind = 'component';
  readonly elementType = 'default';

  public readonly id = 'component-view-state-' + ++id;
  public readonly lookup: ComponentLookup;
  public readonly productLookup: ProductLookup;
  public readonly componentKey: string;

  constructor(public readonly api: ICompositeProductApi, public readonly viewElement: IUICfgComponent) {
    super();
    const source = this.viewElement.source;
    this.componentKey = source.componentKey;
    this.lookup = new ComponentLookup(this.api, this.componentKey);
    componentLookupBehaviour(this.lookup, this);
    this.productLookup = new ProductLookup(this.api, this.componentKey);
    attributeLookupBehaviour(this.productLookup, this);
  }

  get isViewExist() {
    // Always return true - products/attributes should always render
    // The showComponent setting only controls title/description/switcher visibility
    // (handled in ComponentSwitchCfgUIElement)
    return true;
  }

  enabled() {
    return this.lookup.isEnable();
  }

  update() {
    // TODO: Optimization
    this.lookup.updateValues();
    this.productLookup.updateValues();
  }
}
